import type { PublicTemporaryMessage } from '@api-client/temporary-messages';

import { useTemporaryMessages } from './useTemporaryMessages';
import { useUserTypeQueryParam } from './useUserTypeQueryParam';

const POLLING_INTERVAL_IN_MINUTES = 15;

const SECONDS_PER_MINUTE = 60;
const MILLISECONDS_PER_SECOND = 1000;
const POLLING_INTERVAL_IN_MILLISECONDS =
    POLLING_INTERVAL_IN_MINUTES * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;

export function useTemporaryMessagesWithPolling(): PublicTemporaryMessage[] | undefined {
    const userType = useUserTypeQueryParam();
    const { data: temporaryMessages } = useTemporaryMessages(userType, {
        refetchInterval: POLLING_INTERVAL_IN_MILLISECONDS,
    });

    return temporaryMessages;
}
